import { __assign } from '../../node_modules/tslib/tslib.es6.js';
import React, { useEffect } from 'react';
import { Pagination } from '@primer/react';
import { createUniqueID } from '../../utils/functions.js';

var StyledPagination = {
  fontSize: "14px",
  "& > div > a": {
    color: "fg.default",
    "&:hover": {
      backgroundColor: "onHover"
    }
  },
  "& > div > span": {
    color: "#666 !important"
  },
  '& > div > a[aria-current="page"]': {
    backgroundColor: "focus.outlineColor",
    color: "fg.onEmphasis",
    "&:hover": {
      backgroundColor: "focus.outlineColor",
      color: "fg.onEmphasis"
    }
  },
  '& > div > button[aria-disabled="true"]': {
    cursor: "not-allowed !important",
    color: "fg.muted"
  },
  '& > div > button[aria-disabled="true"]:hover': {
    color: "fg.muted"
  }
};
var LTPagination = function LTPagination(_a) {
  var _b = _a.currentPage,
    currentPage = _b === void 0 ? 1 : _b,
    _c = _a.marginPageCount,
    marginPageCount = _c === void 0 ? 1 : _c,
    _d = _a.onChange,
    onChange = _d === void 0 ? function () {} : _d,
    pageCount = _a.pageCount,
    _e = _a.showPages,
    showPages = _e === void 0 ? true : _e,
    _f = _a.styles,
    styles = _f === void 0 ? {} : _f,
    _g = _a.surroundingPageCount,
    surroundingPageCount = _g === void 0 ? 0 : _g;
  var handleChange = function handleChange(e, page) {
    e.preventDefault();
    onChange(e, page);
  };
  var paginationId = createUniqueID("lt_pagination");
  useEffect(function () {
    //remove tab focus from disabled button
    var paginationElement = document.getElementById(paginationId);
    if (paginationElement) {
      var buttonELement = paginationElement.querySelectorAll("button");
      if (buttonELement.length > 0) {
        buttonELement.forEach(function (button) {
          button.setAttribute("tabindex", "-1");
        });
      }
    }
  }, [currentPage]);
  return /*#__PURE__*/React.createElement(Pagination, {
    currentPage: currentPage,
    id: paginationId,
    marginPageCount: marginPageCount,
    onPageChange: handleChange,
    pageCount: pageCount,
    showPages: showPages,
    surroundingPageCount: surroundingPageCount,
    sx: __assign(__assign({}, StyledPagination), styles),
    role: "navigation"
  });
};

export { LTPagination as default };
